import { Box, useColorScheme } from "@mui/joy";
import { useEffect, useState } from "react";

import { AppIconBoldDark, AppIconBoldLight } from "~/common/components/Icons";

interface AppIconProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

export const AppIcon = ({ width = 32, height = 32 }: AppIconProps) => {
  const { mode } = useColorScheme();
  const [mounted, setMounted] = useState(false);
  const [isDark, setIsDark] = useState(mode === "dark");

  useEffect(() => setMounted(true), []);

  useEffect(() => setIsDark(mode === "dark"), [mode]);

  // Prevent hydration mismatch by not rendering until mounted
  if (!mounted) {
    return <div style={{ width, height }} />;
  }

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
      <Box
        sx={(theme) => ({
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 28,
          height: 28,
          borderRadius: theme.vars.radius.sm,
          transition: "background-color 0.2s, color 0.2s",
        })}
      >
        {isDark ? (
          <AppIconBoldLight height={24} width={24} />
        ) : (
          <AppIconBoldDark height={24} width={24} />
        )}
      </Box>
    </Box>
  );
};
